<div class="payment-form-container">
  <div id="zuora-payment-form"></div>
  @if (loading){
  <div class="pf-loading">Loading payment form…</div>
  }
</div>
